import { CircularProgress, Box, useTheme } from '@mui/material';
import useWindowSize from '@shared/hooks/useWindowsSize';

const ButtonContent = ({ isLoading, children }) => {
  const screenSize = useWindowSize();
  const theme = useTheme();

  if (!isLoading) return children;

  return (
    <Box display="flex" justifyContent="center" width="100%">
      <CircularProgress
        size={screenSize.width < 600 ? 20 : 24}
        sx={{ color: theme.text1 }}
      />
    </Box>
  );
};

export default ButtonContent;
